import { Route } from 'react-router-dom'
import { InfiniteLandingPage } from '../infinite-landing-pages/infinite-landing-v1/pages/InfiniteLandingPage'
import { InfiniteLandingPage as InfiniteLandingPageV2 } from '../infinite-landing-pages/infinite-landing-v2/pages/InfiniteLandingPage'

export const InfiniteLandingRoutes = () => [
  <Route key='infinite' path='/infinite' element={<InfiniteLandingPage />} />,
  <Route key='infinite-v2' path='/infinite/v2' element={<InfiniteLandingPageV2 />} />
]
